import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { UpdateMarque } from '../editMarque/updateMarque';
import { DeleteRecord } from '../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useListBackNavigation } from '../../../hooks/listNavigation';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/roles/roleDetailsHeader.css';

const MarqueDetailsHeader = () => {

    const { t } = useTranslation();
    const { goBack, goToList } = useListBackNavigation('/dashboard/marques');
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const marqueDetailsData = useSelector((state) => state.MarqueDetailsData);

    const hasMarqueUpdatePermission = useHasPermission('marques_update');
    const hasMarqueDeletePermission = useHasPermission('marques_delete');

    const [updateMarqueOpen, setUpdateMarqueOpen] = useState(false);
    const [deleteMarqueOpen, setDeleteMarqueOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [errMsg, setErrMsg] = useState(null);

    const openActionMenu = Boolean(anchorEl);

    const handleDeleteMarque = async () => {
        try {
            const response = await axios.delete(`marque/${marqueDetailsData.id}`);
            if (response.status === 200 || response.status === 201) {
                setDeleteMarqueOpen(false);
                goToList();
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error.response?.data?.message || error.message || t('Une erreur est survenue lors de la suppression de la marque.'));
            console.error('Error deleting marque:', error);
            CustomErrorLogger(error, "Delete marque in MarqueDetailsHeader");
        }
    }

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = goBack;

    return (
        <Box className="roleDetailsHeader_mainBox">
            <Box className="roleDetailsHeader_firstPart">
                <Iconify className='roleDetailsHeader_back_icon' icon={"material-symbols:arrow-back"} onClick={handleGoBack} />
                <Typography className="roleDetailsHeader_title">{marqueDetailsData?.name}</Typography>
                {hasMarqueUpdatePermission && <Iconify className='roleDetailsHeader_edit_icon' icon={"ic:outline-edit"} onClick={() => setUpdateMarqueOpen(true)} />}
                {marqueDetailsData?.description}
            </Box>
            <Box className="roleDetailsHeader_secondPart">
                {isDesktop && hasMarqueDeletePermission &&
                    <Box className="roleDetailsHeader_action_box" onClick={() => setDeleteMarqueOpen(true)}>
                        <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                        <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && <Iconify
                    className='roleDetailsHeader_dots_icon'
                    icon={"vaadin:ellipsis-dots-v"}
                    id="userPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />}
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {!isDesktop && hasMarqueDeletePermission &&
                        <MenuItem className='roleDetailsHeader_menuItem' onClick={() => setDeleteMarqueOpen(true)}>
                            <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                            <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>

            {updateMarqueOpen &&
                <UpdateMarque
                    updateMarqueOpen={updateMarqueOpen}
                    setUpdateMarqueOpen={setUpdateMarqueOpen}
                />
            }

            {deleteMarqueOpen &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deleteMarqueOpen}
                    setOpenDelete={setDeleteMarqueOpen}
                    handleDelete={handleDeleteMarque}
                    title="Êtes-vous sûr de vouloir supprimer cette marque ?"
                />
            }
        </Box>
    );
}

export default MarqueDetailsHeader;